// test1543
(1543 && 0);
